import { api } from './client';
import type {
  BannerDto,
  BlogPostDto,
  ContactMessageCreateDto,
  FaqItemDto,
  MenuItemDto,
  NewsletterConfirmResultDto,
  NewsletterSubscribeDto,
  PageDto,
  PagedRequest,
  PagedResult,
} from './types';

/* ------------------------------------------------------------------ *
 *  Icerik ve mağaza ayarlari — 13 uc  (/api/content)
 * ------------------------------------------------------------------ */

export const contentApi = {
  /** 1. Vitrine acik magaza ayarlari (logo, sosyal medya, kargo esigi). */
  publicSettings: () => api.get<Record<string, string | null>>('/api/content/settings'),

  /** 2. Yayindaki statik sayfalarin listesi. */
  pages: () => api.get<PageDto[]>('/api/content/pages'),

  /** 3. Sayfa icerigi (hakkimizda, mesafeli satis sozlesmesi vb.). */
  page: (slug: string) => api.get<PageDto>(`/api/content/pages/${slug}`),

  /** 4. Blog yazilari; kategori ve etikete gore filtrelenebilir. */
  blogPosts: (query: PagedRequest = {}, category?: string, tag?: string) =>
    api.get<PagedResult<BlogPostDto>>('/api/content/blog', { ...query, category, tag }),

  /** 5. Blog yazisi detayi. */
  blogPost: (slug: string) => api.get<BlogPostDto>(`/api/content/blog/${slug}`),

  /** 6. Yayindaki bannerlar; yerlesime gore filtrelenir. */
  banners: (placement?: string) => api.get<BannerDto[]>('/api/content/banners', { placement }),

  /** 7. Banner tiklamasini sayar. */
  trackBannerClick: (id: number) => api.postCommand(`/api/content/banners/${id}/click`),

  /** 8. Menu (ust menu, alt bilgi vb.). */
  menu: (menuKey: string) => api.get<MenuItemDto[]>(`/api/content/menus/${menuKey}`),

  /** 9. Sikca sorulan sorular; kategoriye veya urune bagli olabilir. */
  faq: (category?: string, productId?: number) =>
    api.get<FaqItemDto[]>('/api/content/faq', { category, productId }),

  /** 10. Iletisim formu. */
  submitContact: (dto: ContactMessageCreateDto) => api.postCommand('/api/content/contact', dto),

  /** 11. Bulten kaydi; onay e-postasi gonderilir. */
  subscribeNewsletter: (dto: NewsletterSubscribeDto) =>
    api.postCommand('/api/content/newsletter/subscribe', dto),

  /** 12. Bulten kaydini onaylar (cift onay). */
  confirmNewsletter: (token: string) =>
    api.post<NewsletterConfirmResultDto>(`/api/content/newsletter/confirm?token=${encodeURIComponent(token)}`),

  /** 13. Bulten aboneliginden cikar. */
  unsubscribeNewsletter: (token: string, reason?: string) =>
    api.postCommand(
      `/api/content/newsletter/unsubscribe?token=${encodeURIComponent(token)}` +
        (reason ? `&reason=${encodeURIComponent(reason)}` : ''),
    ),
};
